export default __webpack_public_path__ + "cf08339dbdb2dd6e0d0b5ceb572a138d.svg";